import { useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import ExportButton from "../../../../components/buttons/ExportButton";
import { Toast } from "../../../../components/Toast";
import { useFileNaming } from "../../../../hooks/useFileNaming";

function ExportAdminButton({ adminUsers }) {
  const [isExporting, setIsExporting] = useState(false);
  const { trackEvent } = useAPI();
  const { generateCsvFileName } = useFileNaming();

  function formatAdminUserForExport(adminUser) {
    return {
      "User Name": adminUser.user_name || "",
      "User Email": adminUser.user_email || "",
      Tool: adminUser.tool || "",
      "Tool Email": adminUser.tool_email || "",
      Status: adminUser.ping_status?.status || "",
      "Approved By": adminUser.ping_status?.approved_by || "",
      "Approved At": adminUser.ping_status?.approved_at || "",
      "Admin Types":
        adminUser.admin_permissions
          ?.map((perm) => perm.admin_type)
          .join(", ") || "",
      "Admin Categories":
        adminUser.admin_permissions
          ?.map((perm) => perm.admin_category)
          .join(", ") || "",
      Title: adminUser.hr_info?.title || "",
      Department: adminUser.hr_info?.department || "",
    };
  }

  const generateCSV = (adminUsers) => {
    if (!adminUsers || adminUsers.length === 0) return "";

    const headers = [
      "User Name",
      "User Email",
      "Tool",
      "Tool Email",
      "Status",
      "Approved By",
      "Approved At",
      "Admin Types",
      "Admin Categories",
      "Title",
      "Department",
    ];

    const headerRow = headers.join(",");

    const formattedUsers = adminUsers.map(formatAdminUserForExport);
    const rows = formattedUsers.map(formatRowToCSV).join("\n");

    return headerRow + "\n" + rows;
  };

  function formatRowToCSV(rowData) {
    return Object.values(rowData)
      .map((value) => {
        if (value === null || value === undefined) return '""';
        return `"${String(value).replace(/"/g, '""')}"`;
      })
      .join(",");
  }

  async function handleExport() {
    trackEvent(
      "User click on 'Export' button to download the admin users table"
    );
    if (!adminUsers || adminUsers.length === 0) {
      Toast.error("No admin users available to export");
      return;
    }

    setIsExporting(true);
    try {
      const csvContent = generateCSV(adminUsers);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      // Create a link element and trigger download
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", generateCsvFileName(`admin_users`));
      link.style.visibility = "hidden";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      Toast.error("Failed to export admin permissions, Please try again later");
      trackEvent("Failed to export admin permissions", {
        error: error.message,
      });
    } finally {
      setIsExporting(false);
    }
  }

  return (
    <ExportButton
      handleExport={handleExport}
      disabled={isExporting || !adminUsers || adminUsers.length === 0}
    />
  );
}

export default ExportAdminButton;
